

class PopularHoloController {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('.popular-holo__tab'));
    this.panels = Array.from(root.querySelectorAll('.popular-holo__panel'));
    this.underline = root.querySelector('.popular-holo__underline');
    this.prevBtn = root.querySelector('.popular-holo__arrow--prev');
    this.nextBtn = root.querySelector('.popular-holo__arrow--next');
    this.modal = root.querySelector('[data-holo-modal]');
    this.modalContent = root.querySelector('[data-holo-modal-content]');
    this.toast = root.querySelector('[data-holo-toast]');
    this.currency = root.dataset.currency || window.Shopify?.currency?.active || 'TRY';
    this.openCartAfterAdd = root.dataset.openCart === 'true';
    this.toastTimer = null;
    this.lastFocusedElement = null;

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab));
    });

    this.onResize = () => this.positionUnderline();
    window.addEventListener('resize', this.onResize);

    const activeTab = this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
    if (activeTab) requestAnimationFrame(() => this.positionUnderline(activeTab));

    this.initCoverflow();
    this.attachCardEffects();
    this.attachArrows();
    this.attachSwipe();
    this.attachAddToCart();
    this.attachWishlist();
    this.attachQuickView();
    this.attachModalControls();

    this.onResizeCoverflow = () => {
      this.panels.forEach((panel) => this.layoutPanel(panel, false));
    };
    window.addEventListener('resize', this.onResizeCoverflow);
  }

  activateTab(tab) {
    if (tab.classList.contains('is-active')) return;
    const index = tab.dataset.tabIndex;

    this.tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isTarget = panel.dataset.tabPanel === index;
      panel.classList.toggle('is-active', isTarget);
      if (isTarget) {
        panel.dataset.cfIndex = '0';
      }
    });

    this.positionUnderline(tab);
    this.replayEntrance(index);

    const activePanel = this.panels.find((panel) => panel.dataset.tabPanel === index);
    if (activePanel) {
      requestAnimationFrame(() => this.layoutPanel(activePanel, false));
    }
  }

  positionUnderline(tab) {
    if (!this.underline || window.matchMedia('(max-width: 700px)').matches) return;
    const target = tab || this.tabs.find((item) => item.classList.contains('is-active'));
    if (!target) return;
    this.underline.style.width = `${target.offsetWidth}px`;
    this.underline.style.left = `${target.offsetLeft}px`;
  }

  replayEntrance(index) {
    const panel = this.panels.find((item) => item.dataset.tabPanel === index);
    if (!panel) return;

    panel.querySelectorAll('.product-card-holo').forEach((card) => {
      this.playEntrance(card);
    });
  }

  playEntrance(card) {
    card.classList.remove('ph-entrance');
    void card.offsetWidth;
    card.classList.add('ph-entrance');
    card.addEventListener(
      'animationend',
      () => card.classList.remove('ph-entrance'),
      { once: true }
    );
  }

  /* ---------- Coverflow (3'lü, ortadaki öne, yanlar arkada) ---------- */
  initCoverflow() {
    this.panels.forEach((panel) => {
      if (!panel.dataset.cfIndex) panel.dataset.cfIndex = '0';
      this.layoutPanel(panel, false);
      if (panel.classList.contains('is-active')) {
        panel.querySelectorAll('.product-card-holo').forEach((card) => this.playEntrance(card));
      }
    });

    this.attachCoverflowCardClicks();
  }

  layoutPanel(panel) {
    const carousel = panel.querySelector('.popular-holo__carousel');
    if (!carousel) return;

    const cards = Array.from(panel.querySelectorAll('.product-card-holo'));
    const total = cards.length;
    if (!total) return;

    let activeIndex = parseInt(panel.dataset.cfIndex || '0', 10);
    if (Number.isNaN(activeIndex) || activeIndex < 0 || activeIndex >= total) {
      activeIndex = 0;
      panel.dataset.cfIndex = '0';
    }

    cards.forEach((card, i) => {
      let diff = i - activeIndex;
      if (diff > total / 2) diff -= total;
      if (diff < -total / 2) diff += total;

      let pos;
      if (diff === 0) pos = '0';
      else if (diff === -1) pos = '-1';
      else if (diff === 1) pos = '1';
      else if (diff === -2) pos = '-2';
      else if (diff === 2) pos = '2';
      else pos = 'hidden';

      card.dataset.cfPos = pos;
      card.setAttribute('aria-hidden', pos === '0' ? 'false' : 'true');
      card.tabIndex = pos === '0' || pos === '-1' || pos === '1' ? 0 : -1;
    });

    if (panel.classList.contains('is-active')) {
      const activeCard = cards[activeIndex];
      if (activeCard) carousel.style.height = `${activeCard.offsetHeight}px`;
      this.positionArrows(panel);
      this.updateArrowVisibility(total);
    }
  }

  goTo(panel, index) {
    const total = panel.querySelectorAll('.product-card-holo').length;
    if (!total) return;
    const normalized = ((index % total) + total) % total;
    panel.dataset.cfIndex = String(normalized);
    this.layoutPanel(panel);
  }

  stepActivePanel(direction) {
    const panel = this.panels.find((item) => item.classList.contains('is-active'));
    if (!panel) return;
    const current = parseInt(panel.dataset.cfIndex || '0', 10);
    this.goTo(panel, current + direction);
  }

  attachCoverflowCardClicks() {
    this.panels.forEach((panel) => {
      const cards = Array.from(panel.querySelectorAll('.product-card-holo'));
      cards.forEach((card, i) => {
        const link = card.querySelector('.product-card-holo__link');
        link?.addEventListener('click', (event) => {
          if (card.dataset.cfPos !== '0') {
            event.preventDefault();
            this.goTo(panel, i);
          }
        });
      });
    });
  }

  positionArrows(panel) {
    const carousel = panel.querySelector('.popular-holo__carousel');
    if (!carousel || !this.prevBtn || !this.nextBtn) return;
    const top = carousel.offsetTop + carousel.offsetHeight / 2;
    this.prevBtn.style.top = `${top}px`;
    this.nextBtn.style.top = `${top}px`;
  }

  updateArrowVisibility(total) {
    if (!this.prevBtn || !this.nextBtn) return;
    const shouldShow = total > 1;
    this.prevBtn.style.display = shouldShow ? '' : 'none';
    this.nextBtn.style.display = shouldShow ? '' : 'none';
  }

  /* ---------- Sürükle-kaydır (drag-to-scroll) ---------- */
  attachSwipe() {
    this.panels.forEach((panel) => {
      const carousel = panel.querySelector('.popular-holo__carousel');
      if (!carousel) return;

      // Tarayıcının link/görsel native drag'ını engelle — bu olmadan
      // mouse ile sürüklerken pointermove eventleri bastırılıyor
      carousel.addEventListener('dragstart', (event) => event.preventDefault());

      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let tracking = false;
      let dragged = false;          // gerçek sürükleme oldu mu
      let directionLocked = false;
      let isHorizontal = false;
      const DRAG_THRESHOLD = 8;     // px — sürükleme başlangıç eşiği
      const SNAP_THRESHOLD = 40;    // px — kart değiştirme eşiği
      const MAX_VISUAL = 100;       // px — görsel offset üst sınır

      // Geçici document dinleyicileri (pointerdown'da eklenir, bırakınca kaldırılır)
      let onDocMove = null;
      let onDocUp = null;

      carousel.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        startX = event.clientX;
        startY = event.clientY;
        currentX = startX;
        tracking = true;
        dragged = false;
        directionLocked = false;
        isHorizontal = false;
        carousel.classList.add('is-grab-ready');

        // Document-level dinleyiciler: pointer carousel dışına çıksa bile takip eder
        onDocMove = (moveEvent) => {
          if (!tracking) return;
          currentX = moveEvent.clientX;
          const deltaX = currentX - startX;
          const deltaY = moveEvent.clientY - startY;

          if (!directionLocked) {
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            if (absX > DRAG_THRESHOLD || absY > DRAG_THRESHOLD) {
              directionLocked = true;
              isHorizontal = absX >= absY;
            }
            return;
          }

          if (!isHorizontal) return;

          moveEvent.preventDefault();
          dragged = true;
          carousel.classList.add('is-dragging');

          const clamped = Math.max(-MAX_VISUAL, Math.min(MAX_VISUAL, deltaX * 0.45));
          carousel.style.transform = `translateX(${clamped}px)`;
        };

        onDocUp = () => {
          if (!tracking) return;
          tracking = false;
          carousel.classList.remove('is-grab-ready', 'is-dragging');

          // Görsel offseti animate ile sıfırla
          carousel.style.transition = 'transform 0.3s cubic-bezier(0.22, 0.68, 0, 1)';
          carousel.style.transform = '';
          carousel.addEventListener('transitionend', () => {
            carousel.style.transition = '';
          }, { once: true });

          // Dinleyicileri temizle
          document.removeEventListener('pointermove', onDocMove);
          document.removeEventListener('pointerup', onDocUp);
          document.removeEventListener('pointercancel', onDocUp);

          if (!isHorizontal || !dragged) return;

          const deltaX = currentX - startX;
          if (Math.abs(deltaX) > SNAP_THRESHOLD) {
            const current = parseInt(panel.dataset.cfIndex || '0', 10);
            this.goTo(panel, current + (deltaX < 0 ? 1 : -1));
          }
        };

        document.addEventListener('pointermove', onDocMove);
        document.addEventListener('pointerup', onDocUp);
        document.addEventListener('pointercancel', onDocUp);
      });

      // Sürükleme sırasında link tıklamalarını engelle
      carousel.addEventListener('click', (event) => {
        if (dragged) {
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }
      }, true);
    });
  }

  attachCardEffects() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    this.root.querySelectorAll('.product-card-holo').forEach((card) => {
      card.addEventListener('mousemove', (event) => {
        if (card.dataset.cfPos !== '0') return;

        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        const rotateX = (0.5 - y) * 8;
        const rotateY = (x - 0.5) * 10;

        card.style.transform = `translate(-50%, 0) scale(1) translateY(-4px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
        card.style.setProperty('--mx', `${x * 100}%`);
        card.style.setProperty('--my', `${y * 100}%`);
      });

      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
      });
    });
  }

  attachArrows() {
    this.prevBtn?.addEventListener('click', () => this.stepActivePanel(-1));
    this.nextBtn?.addEventListener('click', () => this.stepActivePanel(1));
  }

  attachAddToCart() {
    this.root.querySelectorAll('[data-product-form-holo]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        await this.addFormToCart(form, button);
      });
    });
  }

  async addFormToCart(form, button) {
    if (button) button.disabled = true;

    try {
      const formData = new FormData(form);
      const item = await this.addToCart(formData);
      await this.afterCartAdd(item);

      if (button) {
        button.classList.add('is-added');
        setTimeout(() => button.classList.remove('is-added'), 1200);
      }

      this.showToast('Ürün sepete eklendi.');
    } catch (error) {
      console.error('[Popular Holo] Sepete ekleme hatası:', error);
      this.showToast(error?.message || 'Ürün sepete eklenemedi.');
    } finally {
      if (button) button.disabled = false;
    }
  }

  async addVariantToCart(variantId, quantity = 1) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    const item = await this.addToCart(formData);
    await this.afterCartAdd(item);
    this.showToast('Ürün sepete eklendi.');
    return item;
  }

  async addToCart(formData) {
    const rootPath = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootPath}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
    }
    return data;
  }

  async afterCartAdd(item) {
    await this.refreshCartCount();

    const detail = { item, source: 'popular-holo' };
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail }));

    if (this.openCartAfterAdd) {
      window.setTimeout(() => this.tryOpenCartDrawer(), 100);
    }
  }

  async refreshCartCount() {
    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootPath}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      const count = cart.item_count ?? 0;

      const selectors = [
        '[data-cart-count]',
        '.cart-count-bubble span[aria-hidden="true"]',
        '.cart-count-bubble',
        '.cart-count',
        '.header-cart-count',
        '.minicart-count',
      ];

      document.querySelectorAll(selectors.join(',')).forEach((element) => {
        if (element.children.length === 0 || element.matches('[data-cart-count], .cart-count, .header-cart-count, .minicart-count')) {
          element.textContent = String(count);
        }
        element.classList.toggle('is-empty', count === 0);
      });
    } catch (error) {
      console.warn('[Popular Holo] Sepet sayacı güncellenemedi:', error);
    }
  }

  tryOpenCartDrawer() {
    const candidates = [
      '[data-cart-drawer-trigger]',
      '[data-open-cart]',
      'a[href="#mini_cart"]',
      'a[href="#cart-drawer"]',
      '.header__icon--cart',
      '.header-cart',
      '.js-cart-drawer-open',
    ];

    const trigger = candidates
      .map((selector) => document.querySelector(selector))
      .find((element) => element && !this.root.contains(element));

    if (trigger) trigger.click();
  }

  getWishlist() {
    try {
      const value = JSON.parse(localStorage.getItem('popularHoloWishlist') || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  saveWishlist(items) {
    localStorage.setItem('popularHoloWishlist', JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('popular-holo:wishlist-change', { detail: { items } }));
  }

  attachWishlist() {
    const buttons = Array.from(this.root.querySelectorAll('[data-wishlist-btn]'));
    if (!buttons.length) return;

    const syncButtons = () => {
      const savedIds = new Set(this.getWishlist().map((item) => String(item.id)));
      buttons.forEach((button) => {
        const active = savedIds.has(String(button.dataset.productId));
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.title = active ? 'Favorilerden Çıkar' : 'Favorilere Ekle';
      });
    };

    syncButtons();

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = String(button.dataset.productId || '');
        if (!id) return;

        const items = this.getWishlist();
        const existingIndex = items.findIndex((item) => String(item.id) === id);

        if (existingIndex >= 0) {
          items.splice(existingIndex, 1);
          this.showToast('Ürün favorilerden çıkarıldı.');
        } else {
          items.push({
            id,
            handle: button.dataset.productHandle || '',
            url: button.dataset.productUrl || '',
            title: button.dataset.productTitle || '',
            image: button.dataset.productImage || '',
            price: button.dataset.productPrice || '',
          });
          this.showToast('Ürün favorilere eklendi.');
        }

        this.saveWishlist(items);
        syncButtons();
      });
    });

    window.addEventListener('storage', (event) => {
      if (event.key === 'popularHoloWishlist') syncButtons();
    });
  }

  attachQuickView() {
    this.root.querySelectorAll('[data-quick-view-btn]').forEach((button) => {
      button.addEventListener('click', async () => {
        const productUrl = button.dataset.productUrl;
        if (!productUrl || !this.modal || !this.modalContent) return;

        this.lastFocusedElement = button;
        this.openModal();
        this.modalContent.innerHTML = '<div class="popular-holo__modal-loading">Ürün yükleniyor…</div>';

        try {
          const product = await this.fetchProduct(productUrl);
          this.renderQuickView(product, productUrl);
        } catch (error) {
          console.error('[Popular Holo] Hızlı görünüm hatası:', error);
          this.modalContent.innerHTML = `<div class="popular-holo__modal-error">Hızlı görünüm yüklenemedi.<br><a class="popular-holo__modal-link" href="${this.escapeHtml(productUrl)}">Ürün sayfasına git</a></div>`;
        }
      });
    });
  }

  async fetchProduct(productUrl) {
    const cleanUrl = productUrl.split('?')[0].replace(/\/$/, '');
    const response = await fetch(`${cleanUrl}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Ürün bilgisi alınamadı.');
    return response.json();
  }

  renderQuickView(product, productUrl) {
    if (!this.modalContent) return;

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const firstAvailable = variants.find((variant) => variant.available) || variants[0];
    const image = this.getProductImage(product, firstAvailable);
    const options = variants.map((variant) => {
      const disabled = variant.available ? '' : ' disabled';
      const suffix = variant.available ? '' : ' — Tükendi';
      return `<option value="${variant.id}" data-price="${variant.price}" data-compare="${variant.compare_at_price || 0}" data-image="${this.escapeHtml(this.variantImageUrl(variant, product))}"${disabled}>${this.escapeHtml(variant.title)}${suffix}</option>`;
    }).join('');

    const showVariantSelect = variants.length > 1 || (variants[0] && variants[0].title !== 'Default Title');
    const price = firstAvailable ? firstAvailable.price : product.price;
    const compare = firstAvailable ? firstAvailable.compare_at_price : product.compare_at_price;

    this.modalContent.innerHTML = `
      <div class="popular-holo__modal-grid">
        <div class="popular-holo__modal-media">
          ${image ? `<img src="${this.escapeHtml(image)}" alt="${this.escapeHtml(product.title)}" data-holo-modal-image>` : ''}
        </div>
        <div class="popular-holo__modal-info">
          <h3 class="popular-holo__modal-title">${this.escapeHtml(product.title)}</h3>
          <p class="popular-holo__modal-price" data-holo-modal-price>
            ${this.formatMoney(price)}
            ${compare && compare > price ? `<s class="popular-holo__modal-compare">${this.formatMoney(compare)}</s>` : ''}
          </p>
          ${showVariantSelect ? `
            <label class="popular-holo__modal-label" for="HoloVariant-${this.root.dataset.sectionId}">Seçenek</label>
            <select class="popular-holo__modal-select" id="HoloVariant-${this.root.dataset.sectionId}" data-holo-variant-select>${options}</select>
          ` : `<input type="hidden" data-holo-variant-select value="${firstAvailable?.id || ''}">`}
          <div class="popular-holo__modal-actions">
            <button type="button" class="popular-holo__modal-add" data-holo-modal-add ${firstAvailable?.available ? '' : 'disabled'}>${firstAvailable?.available ? 'Sepete Ekle' : 'Tükendi'}</button>
            <a class="popular-holo__modal-link" href="${this.escapeHtml(productUrl)}">Ürünü İncele</a>
          </div>
        </div>
      </div>
    `;

    const select = this.modalContent.querySelector('[data-holo-variant-select]');
    const addButton = this.modalContent.querySelector('[data-holo-modal-add]');

    if (select?.tagName === 'SELECT' && firstAvailable) {
      select.value = String(firstAvailable.id);
      select.addEventListener('change', () => this.updateQuickViewVariant(select, product));
    }

    addButton?.addEventListener('click', async () => {
      const variantId = select?.value;
      if (!variantId) return;
      addButton.disabled = true;
      const oldText = addButton.textContent;
      addButton.textContent = 'Ekleniyor…';

      try {
        await this.addVariantToCart(variantId, 1);
        addButton.textContent = 'Sepete Eklendi';
        setTimeout(() => {
          if (this.modal && !this.modal.hidden) addButton.textContent = oldText;
        }, 1200);
      } catch (error) {
        this.showToast(error?.message || 'Ürün sepete eklenemedi.');
        addButton.textContent = oldText;
      } finally {
        addButton.disabled = false;
      }
    });
  }

  updateQuickViewVariant(select, product) {
    const option = select.options[select.selectedIndex];
    if (!option) return;

    const price = Number(option.dataset.price || 0);
    const compare = Number(option.dataset.compare || 0);
    const priceElement = this.modalContent?.querySelector('[data-holo-modal-price]');
    const imageElement = this.modalContent?.querySelector('[data-holo-modal-image]');
    const addButton = this.modalContent?.querySelector('[data-holo-modal-add]');
    const variant = product.variants?.find((item) => String(item.id) === String(select.value));

    if (priceElement) {
      priceElement.innerHTML = `${this.formatMoney(price)}${compare > price ? `<s class="popular-holo__modal-compare">${this.formatMoney(compare)}</s>` : ''}`;
    }

    const imageUrl = option.dataset.image;
    if (imageElement && imageUrl) imageElement.src = imageUrl;

    if (addButton) {
      addButton.disabled = !variant?.available;
      addButton.textContent = variant?.available ? 'Sepete Ekle' : 'Tükendi';
    }
  }

  getProductImage(product, variant) {
    return this.variantImageUrl(variant, product) || product.featured_image || product.images?.[0] || '';
  }

  variantImageUrl(variant, product) {
    const image = variant?.featured_image;
    if (typeof image === 'string') return image;
    if (image?.src) return image.src;
    return product?.featured_image || product?.images?.[0] || '';
  }

  attachModalControls() {
    if (!this.modal) return;

    this.modal.querySelectorAll('[data-holo-modal-close]').forEach((button) => {
      button.addEventListener('click', () => this.closeModal());
    });

    this.onKeydown = (event) => {
      if (event.key === 'Escape' && !this.modal.hidden) this.closeModal();
    };
    document.addEventListener('keydown', this.onKeydown);
  }

  openModal() {
    if (!this.modal) return;
    this.modal.hidden = false;
    document.documentElement.classList.add('popular-holo-modal-open');
    document.body.style.overflow = 'hidden';
    this.modal.querySelector('[data-holo-modal-close]')?.focus();
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.hidden = true;
    document.documentElement.classList.remove('popular-holo-modal-open');
    document.body.style.overflow = '';
    this.lastFocusedElement?.focus();
  }

  formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {
        style: 'currency',
        currency: this.currency,
      }).format(amount);
    } catch (error) {
      return `${amount.toFixed(2)} ${this.currency}`;
    }
  }

  showToast(message) {
    if (!this.toast) return;
    this.toast.textContent = message;
    this.toast.classList.add('is-visible');
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => {
      this.toast?.classList.remove('is-visible');
    }, 2200);
  }

  escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
}

function initPopularHoloSections(root = document) {
  const sections = root.matches?.('.popular-holo')
    ? [root]
    : Array.from(root.querySelectorAll?.('.popular-holo') || []);

  sections.forEach((section) => {
    if (section.dataset.holoInit === 'true') return;
    section.dataset.holoInit = 'true';
    section._popularHoloController = new PopularHoloController(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPopularHoloSections());
} else {
  initPopularHoloSections();
}

document.addEventListener('shopify:section:load', (event) => {
  initPopularHoloSections(event.target);
});